var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      !_vm.mobileView
        ? _c(
            "div",
            { staticStyle: { "min-height": "135px" }, attrs: { id: "oblea" } },
            [
              _c("div", { attrs: { id: "s1" } }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.imagenProducto != null,
                      expression: "imagenProducto != null"
                    }
                  ],
                  staticStyle: {
                    width: "85%",
                    height: "85%",
                    "object-fit": "contain",
                    "margin-top": "10px"
                  },
                  attrs: { id: "imagenProducto", src: _vm.imagenProducto }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv lc",
                  staticStyle: { width: "65%", height: "100%" }
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        color: "#656E76",
                        "margin-top": "8px",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Nombre))]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "9px",
                        color: "#656E76",
                        "margin-top": "2px",
                        height: "7px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Observacion))]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        color: "#656E76",
                        "font-weight": "bold",
                        "margin-top": "12px"
                      }
                    },
                    [_vm._v(" Contenido: ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "5px",
                        "margin-top": "2px",
                        "font-size": "10px",
                        color: "#656E76",
                        "font-weight": "normal",
                        height: "40px",
                        overflow: "auto"
                      }
                    },
                    [
                      _c(
                        "ul",
                        _vm._l(_vm.productos, function(producto) {
                          return _c("li", [_vm._v(_vm._s(producto))])
                        })
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "margin-top": "15px",
                        "margin-bottom": "10px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh cc",
                          staticStyle: {
                            width: "50%",
                            height: "100%",
                            "font-size": "10px",
                            color: "#656E76",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _vm._v(
                            "Precio Habitual: $" +
                              _vm._s(
                                _vm._f("formatMoney")(_vm.getPrecioHabitual)
                              )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh cc",
                          staticStyle: {
                            width: "50%",
                            height: "100%",
                            "font-size": "10px",
                            color: "#656E76",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _vm._v(
                            "Precio Promocional: $" +
                              _vm._s(
                                _vm._f("formatMoney")(_vm.getPrecioPromocional)
                              )
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "45px" }, attrs: { id: "s3" } },
                [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnAgregar" },
                      on: { click: _vm.btnAgregar }
                    },
                    [_vm._v("AGREGAR")]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c(
            "div",
            {
              staticClass: "oblea-mobile",
              staticStyle: {
                width: "90vw",
                "padding-top": "10px",
                "padding-bottom": "10px",
                display: "flex",
                "flex-direction": "row",
                "align-items": "flex-start",
                "justify-content": "flex-start"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: { width: "30%", height: "100%" }
                },
                [
                  _c("img", {
                    staticStyle: {
                      width: "80%",
                      height: "80%",
                      "object-fit": "contain"
                    },
                    attrs: { id: "imagenProducto", src: _vm.imagenProducto }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv lc",
                  staticStyle: { width: "55%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "margin-left": "10px",
                        "font-size": "16px",
                        color: "#5D6770",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Nombre))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "margin-left": "10px",
                        "font-size": "9px",
                        color: "#5D6770",
                        "font-weight": "400",
                        "margin-top": "5px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Observacion))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "margin-left": "10px",
                        "font-size": "11px",
                        color: "#5D6770",
                        "margin-top": "10px"
                      }
                    },
                    [
                      _vm._v(
                        "Precio Habitual: $" +
                          _vm._s(_vm._f("formatMoney")(_vm.getPrecioHabitual))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "margin-left": "10px",
                        "font-size": "11px",
                        color: "#5D6770",
                        "margin-top": "2px",
                        "font-weight": "500"
                      }
                    },
                    [
                      _vm._v(
                        "Precio Promo: $" +
                          _vm._s(
                            _vm._f("formatMoney")(_vm.getPrecioPromocional)
                          )
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: { width: "15%", height: "100%" }
                },
                [
                  _c("img", {
                    staticStyle: { height: "20px" },
                    attrs: { src: "/dist/carrito-gris.svg" },
                    on: { click: _vm.btnAgregar }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47eca532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47eca532","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/itemPromociones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-47eca532","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/itemPromociones.vue
// module chunks = 0